module.exports = __webpack_public_path__ + "img/Kreditkarte_200x104_V2.933a356.svg";